export enum RegimenClass {
  Face = 'FACE',
  Hair = 'HAIR',
  Both = 'BOTH',
}
